import axios from "axios";

const store = {
    state: {
    },

    getters: {
    },

    mutations: {
    },

    actions: {
        findAccountsAction() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/payment/find-accounts`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        storeAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payment/store`, payload)
                    .then((res) => {
                        resolve(res.data.payment);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        updateAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payment/update`, payload)
                    .then((res) => {
                        resolve(res.data.payment);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findPayments(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payment/find-payments`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deletePaymentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/payment/${payload.paymentId}`,)
                    .then(() => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findCloseAction() {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payment/close/find-last`,)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        processPercentageAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payment/percentege/store`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },


        findLastPercentageAction() {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payment/percentege/find-last`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    },
};

export default store;
